
import Vue, { PropType } from "vue";

class Marker {
  id!: number;
  company?: string;
  address1?: string;
  city?: string;
  state?: string;
  postalCode?: string;
  phone?: string;
  website?: string;
  position?: google.maps.LatLngLiteral;

  public constructor(init?: Partial<Marker>) {
    Object.assign(this, init);
  }
}
export default Vue.extend({
  props: {
    google: {
      type: Array as unknown as PropType<
        [
          google.maps.PlacesLibrary,
          google.maps.MapsLibrary,
          google.maps.CoreLibrary,
          google.maps.MarkerLibrary
        ]
      >,
      required: true,
    },
    map: {
      type: Object,
      required: true,
    },
    marker: {
      type: Object as PropType<Marker>,
      required: true,
    },
    info: {
      type: String,
      required: false,
      default: "",
    },
  },
  computed: {
    markerInfo(): string {
      const markerObject = this.marker as Marker;
      const content =
        "<div class='popper-info'><strong>" +
        markerObject.company +
        "</strong><br/>" +
        markerObject.address1 +
        "<br/>" +
        markerObject.city +
        " " +
        markerObject.state +
        ", " +
        markerObject.postalCode +
        "<br/>" +
        markerObject.phone +
        '<br/><a href="' +
        markerObject?.website +
        '" target="_blank">' +
        markerObject?.website +
        "</a>" +
        "</div>";
      return content;
    },
    iconUrl(): string {
      return this.$config.cdn + "bf-map-marker-blue.png";
    },
  },
  mounted() {
    const [PlacesLibrary, MapsLibrary, CoreLibrary, MarkerLibrary] =
      this.google;

    const { InfoWindow } = MapsLibrary;
    const { AdvancedMarkerElement } = MarkerLibrary;
    const mark1 = new AdvancedMarkerElement({
      position: this.marker.position,
      map: this.map,
      content: this.$el,
    });

    const infoWindow = new InfoWindow({
      content: this.markerInfo,
    });
    const { company, address1, city, state, phone, postalCode, website } =
      this.marker;
    const _this = this;
    CoreLibrary.event.addListener(mark1, "click", function () {
      _this.map.setCenter(mark1.position);
      infoWindow.setContent(
        "<div class='popper-info'><strong>" +
          company +
          "</strong><br/>" +
          address1 +
          "<br/>" +
          city +
          " " +
          state +
          ", " +
          postalCode +
          "<br/>" +
          phone +
          '<br/><a href="' +
          website +
          '" target="_blank">' +
          website +
          "</a></div>"
      );
      infoWindow.open(_this.map, mark1);
    });
  },
});
